module.exports = __webpack_public_path__ + "img/icon-cooporativo.1a113b90.svg";